import React,{useContext} from 'react';
import './Folder.css';

import {ContextGame} from '../GameProvider';
import {ContextPlayer} from '../player/PlayerProvider';
import {ContextGlobal} from '../../globalProvider';

import reactStringReplace from 'react-string-replace'; 

function Folder(){

  const {state} = useContext(ContextGame);
  const player = useContext(ContextPlayer);
  const global = useContext(ContextGlobal);

  const [informs, setInforms] = React.useState();
  const [nInfo, setnInfo] = React.useState(0);
  
  const [styleOpen, setStyleOpen] = React.useState({display:"none"}); 


  const styleDisplay = (!global.state.isMobile)?{display:"inherit"}:(!player.state.initGame)?{display:"inherit"}:{display:"none"};
  const stylePrevious = (nInfo === 0)?{opacity:0}:{};
  const styleNext = (global.state.isMobile || informs === undefined)?{}:(nInfo === informs.length - 1)?{opacity:0}:{};

   
  React.useEffect(()=>{
    setInforms(() => state.games[state.id].informs);
    return () => setnInfo(() => 0);
  }, [state]); 

  const handleNext = () => {
    const nSlides =  informs.length - 1;
  
    if(nInfo < nSlides){
      setnInfo(() => nInfo+1);
    }else if(!player.state.initGame){
      player.dispatch({type:"UpdateInitGame"});
    }
  }

  const handlePrevious = () => {
    if(nInfo > 0){
      setnInfo(() => nInfo-1);
    }
  }

  const handleImageClick = () => {
    (styleOpen.display === "none")?setStyleOpen({display:"inherit"}):setStyleOpen({display:"none"});       
  };

  if(informs !== undefined){
    return (
      <div className="info column nowrap centerItens" style={styleDisplay}>
        <div className = 'boxOpacity column nowrap centerItens'>
        <img className="infoImage" onClick={handleImageClick} src={"/app/CNPD-v2/"+informs[nInfo].image} alt={"Imagem do "+ informs[nInfo].title}/>
        <span className="infoTitle centerText">{informs[nInfo].title}</span>
        <div className="inform row nowrap centerItens">
          <button style={stylePrevious} className="infoPrevious " onClick={handlePrevious}>&lt;</button>
          <span className="infoText justifyText interWordTextJustify shadow">
            {reactStringReplace(informs[nInfo].text, /<i>(.*?)<\/i>/g, (match, a) => (
              <i key={a}>{match}</i>
            ))}
          </span>
          <button className="infoNext " onClick={handleNext} style = {styleNext}>&gt;</button>
        </div>
        <div className="open row nowrap spaceAroundContent centerItens" style={styleOpen} onClick={handleImageClick}>
          <img className="openImage shadow" src={"/app/CNPD-v2/"+informs[nInfo].image} alt={"Imagem do "+ informs[nInfo].title}/>
        </div>
        </div>
      </div> 
    );
  }
  return (<div></div>)
}

export default Folder;
